import { ReactNode, useReducer } from "react";
import { type DateState } from "types/dates";
import { DatesContext, DatesDispatchContext } from "../context/DatesContext";
import { datesReducer } from "../reducers/datesReducer";

export const DatesProvider = ({ children }: { children: ReactNode }) => {
  const initialState: DateState = {
    dates: [],
    dateType: "FULL",
    ranges: [],
  };

  const [state, dispatch] = useReducer(datesReducer, initialState);

  return (
    <DatesContext.Provider value={state}>
      <DatesDispatchContext.Provider value={dispatch}>
        {children}
      </DatesDispatchContext.Provider>
    </DatesContext.Provider>
  );
};
